import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function HookSection() {
  return <section className="py-10 px-4 md:px-8 bg-[#0f1628]/40 border-y border-cyan-500/10 relative" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="bg-[#0f1628]/50 border border-slate-600/20 p-8 md:p-12 rounded-2xl relative overflow-hidden" data-id="element-72">
          <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-73">
            <Clock size={120} data-id="element-74" />
          </div>

          <div className="relative z-10" data-id="element-75">
            <p className="text-xl md:text-2xl font-heading italic text-white leading-relaxed mb-6" data-id="element-76">
              "Son las 3:14 AM. Estás mirando el techo, calculando mentalmente
              cuántas horas de sueño te quedan si lograras dormirte 'ahora
              mismo'."
            </p>
            <p className="text-lg text-[#b8c4d6] leading-relaxed mb-6" data-id="element-77">
              Sientes un calor incómodo en las piernas, tu mente repasa una
              conversación de hace tres días y, lo peor de todo, es que mañana
              tienes que rendir al 100%.
            </p>
            <p className="text-lg text-[#b8c4d6] leading-relaxed" data-id="element-78">
              Esa sensación de{' '}
              <span className="text-white font-semibold" data-id="element-79">
                "cerebro encendido"
              </span>{' '}
              no es falta de cansancio; es una señal de que tu biología está
              desajustada. Tu cuerpo cree que debe estar alerta para sobrevivir,
              cuando lo único que necesitas es descansar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}